<template>
    <vue-draggable-resizable
        v-if="type==='text'"
        :w="textMaxWidth"
        :h="textMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        class-name="text-drag-form vdr"
        :x='currentX'
        :y='currentY'
    >
        <v-textarea
            :label="currentLabel"
            class="pdftextfield"
            outlined
            rows="1"
            wrap="off"
            auto-grow
            :background-color="bgColorsIdMap[currentDestinationId]"
            hide-details
            :color="colorsIdMap[currentDestinationId]"
            :readonly="createUserId!==currentDestinationId"
            v-model="currentValue"
            disabled
            :height="textMaxHeight"
        >
        </v-textarea>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='select'"
        :w="selectMaxWidth"
        :h="selectMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        class-name="text-drag-form vdr"
        :x='currentX'
        :y='currentY'
    >
        <v-select
          v-model="currentValue"
          :items="currentSelectItems"
          class="pdfselectfield"
          :label="currentLabel"
          :background-color="bgColorsIdMap[currentDestinationId]"
          :color="colorsIdMap[currentDestinationId]"
          :readonly="createUserId!==currentDestinationId"
          no-data-text=""
          outlined
          disabled
          :height="selectMaxHeight"
          hide-details="auto"
        ></v-select>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='checkbox'"
        :w="checkboxMaxWidth"
        :h="checkboxMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        :x='currentX'
        :y='currentY'
        class-name="checkbox-drag-form vdr"
        :style="{backgroundColor: bgColorsIdMap[currentDestinationId]}"
    >
        <label class="checkbox-input">
            <input 
                type="checkbox"
                v-model="currentDefault"
                disabled
            >
            <span class="checkbox-image"></span>
         </label>
    </vue-draggable-resizable>
    <vue-draggable-resizable
        v-else-if="type==='seal' || type==='square-seal'"
        :key="sealMaxHeight"
        :w="sealMaxWidth"
        :h="sealMaxHeight"
        :resizable="false"
        :parent="true"
        :drag-handle="'.drag-handle'"
        :x='currentX'
        :y='currentY'
        class-name="seal-drag-form vdr"
        :style="bgStyle"
    >
    
        <v-img
            :width="sealImageWidth"
            :height="sealImageHeight"
            :src="currentSealData"
            :contain="true"
            v-show="currentSealData != ''"
            class="seal-preview"
        >
        </v-img>
        <span
            class="circle"
            :style="'border: solid 3px '+colorsIdMap[currentDestinationId] + '; cursor: default;'"
            v-show="currentSealData === ''"
        >
        </span>
    </vue-draggable-resizable>
</template>
<script>
    import { getTextSize } from '../../common/textUtil.js';
    import { getImgInfo } from '../../common/imageUtil.js';
    export default {
        props: [
            'type',
            'x',
            'y',
            'value',
            'label',
            'required',
            'defaultValue',
            'destinationId',
            'page',
            'pdfId',
            'color',
            'colorsIdMap',
            'bgColorsIdMap',
            'createUserId',
            'selectItems',
        ],
        data() {
            return {
                textMaxWidth: 200,
                textMaxHeight: 29.5,
                selectMaxWidth: 200,
                selectMaxHeight:29.5,
                checkboxMaxWidth: 40,
                checkboxMaxHeight: 43,
                sealMaxWidth: 60,
                sealMaxHeight: 60,
                sealImageWidth: 40,
                sealImageHeight: 40,
                currentDestinationId: 0,
                currentValue: '',
                currentLabel: '',
                currentRequired: false,
                currentDefault: false,
                sealDialog: false,
                currentSealData: '',
                currentX: 0,
                currentY: 0,
                currentSelectItems: [],
            };
        },
        computed: {
            bgStyle: {
                get() {
                    if (this.currentSealData === ''){
                        return { backgroundColor: this.bgColorsIdMap[this.currentDestinationId] };
                    }else{
                        return {};
                    }
                },
                set() {}
            },
        },
        created:async function () {
            this.currentDestinationId = this.destinationId;
            this.currentValue = this.value;
            this.currentSelectItems = this.selectItems? this.selectItems : [];
            this.currentLabel = this.label;
            this.currentRequired = this.required;
            this.currentDefault = this.defaultValue;
            this.currentSealData = this.value? this.value : "";
            this.currentX = this.x;
            this.currentY = this.y;
            if (this.type == "text" && this.currentValue != null) {
             await getTextSize(this.currentValue).then( value => {
                  this.textMaxWidth = value.textMaxWidth
                  this.textMaxHeight = value.textMaxHeight
              })
            }
            if (this.type == "seal") {
                let img = getImgInfo(this.currentValue,40)
                img.then(res=>{
                    let self = this
                    self.sealImageWidth = res.width
                    self.sealImageHeight = res.height
                    self.sealMaxWidth = res.width + 20
                    self.sealMaxHeight = res.height + 20
                })
            }else if(this.type == "square-seal"){
                await getImgInfo(this.currentValue,70).then(res=>{
                    let self = this
                    self.sealImageWidth = res.width
                    self.sealImageHeight = res.height
                    self.sealMaxWidth = res.width + 20
                    self.sealMaxHeight = res.height + 20
                })
            }
        },
        mounted: function () {
            if (this.type == "text" && this.currentValue != null) {
                this.$el.style.setProperty("--textMaxHeight", this.textMaxHeight + 'px')
            }
        },
    }

</script>
<style scoped>
    .circle{
      display: inline-block;
      margin: 9px;
      width: 40px;
      height: 40px;
      text-align:center;
      line-height: 40px;
      border-radius: 50%;
      border: solid 3px blue;
      background-color: #FFF;
    }
    
    .seal-preview {
        margin: 9px;
    }
        
    .pdftextfield::v-deep .v-input__slot {
        min-height:var(--textMaxHeight);
    }
    
    .pdftextfield::v-deep .v-label {
        top:3px !important;
        font-size: 1.6rem !important;
    }
    
    .pdftextfield::v-deep .v-label--active {
        transform: translateY(-12px) scale(.75);
    }
    
    .pdfselectfield {
        font-family: 'IPAexゴシック';
    }
    
    .pdfselectfield::v-deep .v-input__slot {
        min-height:var(--selectMaxHeight);
        font-size: 10.5px !important;
    }
    
    .pdfselectfield::v-deep .v-input__append-inner {
        margin-top: 0px !important;
    }
    
    .pdfselectfield::v-deep .v-label {
        top:3px !important;
        font-size: 1.6rem !important;
        color: rgba(0, 0, 0, 0.6) !important
    }
    
    .pdfselectfield::v-deep .v-label--active {
        transform: translateY(-10px) scale(.75);
        color: rgba(0, 0, 0, 0.6) !important
    }
</style>